import MeetingsGQL from '../../graphql-operations/meetings.graphql';
import RoomGQL from '../../graphql-operations/rooms.graphql';
import StudentsGQL from '../../graphql-operations/students.graphql';
import MockMeetingService from '../mock-json-services/meeting.service';
import MockRoomService from '../mock-json-services/room.service';
import MockStudentService from '../mock-json-services/student.service';

const mocks = [
    {
        request: {
            query: RoomGQL.ROOM_QUERY,
            variables: { roomName: 'AdmissionsOffice' },
        },
        result: { data: { room: MockRoomService.getRoomByName('AdmissionsOffice') } },
    },
    {
        request: {
            query: StudentsGQL.STUDENT_QUERY,
            variables: { email: 'james.dean@gmail.com', studentId: undefined, mobilePhone: undefined }, // Undefined arguments must be included (as undefined)
        },
        result: { data: { student: MockStudentService.getStudent('james.dean@gmail.com') } },
    },
    {
        request: {
            query: MeetingsGQL.MEETINGS_QUERY,
            variables: { roomName: 'AdmissionsOffice' },
        },
        result: { data: { meetings: MockMeetingService.getMeetingsForRoom('0') } },
    },
    {
        request: {
            query: MeetingsGQL.MEETINGS_SUBSCRIPTION,
            variables: { roomName: 'AdmissionsOffice', roomId: '0' },
        },
        result: { data: { meetings: MockMeetingService.getMeetingsForRoom('0') } },
    },
    {
        request: {
            query: MeetingsGQL.MEETINGS_MUTATION,
            variables: {
                additionalInformation: undefined,
                advisorId: undefined,
                advisorRequested: 'First Available',
                preferredPhoneNumber: '(119)823-3883',
                reasonId: '0',
                roomId: '0',
                studentId: '0',
            },
        },
        result: { data: { id: '0' } },
    },
];

export default mocks;



// WEBPACK FOOTER //
// ./src/mocks/mock-graphql-operations/mocks.js